import React from 'react';
import {Route} from 'react-router-dom';
import ContentRouteForward from '../ContentRouteForward';

// TODO(v6): verify prefix - v5 route was non-exact so it also matched
// "/business/showcase/content/:pageKey" sub-paths; using '/*' here to
// preserve that prefix-match behavior.
export default [
  <Route
    key="/business/showcase/content/:pageKey"
    path="business/showcase/content/*"
    element={<ContentRouteForward />}
  />,
];
